import client from "../Client/HttpClient";
import { ISystemAcademicAssignmentsModel } from "@/interfaces/modules";

const ApiPath = "AcademicAssignments";

export default {
  GetAssignments: (): Promise<ISystemAcademicAssignmentsModel[]> => client.get(`${ApiPath}`),
  GetAssignmentById: (data: ISystemAcademicAssignmentsModel): Promise<ISystemAcademicAssignmentsModel> =>
    client.get(`${ApiPath}/${data.Id}`),
  PostAssignment: (data: any): Promise<any> => client.post(`${ApiPath}`, data),
};
